<template>
    <span :class="['authorize', 'like-this', isLiked ? 'liked' : '']" :data-id="targetId" @click.prevent='toggle'>
        <span class="like-count" :data-value="likes+delta" :style="{display: (likes+delta>0) ? 'inline-block':'none'}">{{likes+delta}}</span>
        <span class="authorize cmd-like">
            {{isLiked ? '♥' : '♡' }}
        </span>
    </span>
</template>

<script>
import Api from '@root/components/api';

export default {     
    name: 'like',
    data: function () {
        return {
            pressed: false,
            delta: 0,
        };
    },
    props: ['targetId', 'likes', 'liked'],
    computed: {
        isLiked: function () {
            if (this.liked !== undefined) return this.liked ^ this.pressed;
            const likes = globalThis.likes || {};
            let liked = likes[this.targetId] || false;
            return liked ^ this.pressed;
        },
    },
    methods: {
        like: async function () {
            this.delta = this.delta + 1;
            this.pressed = !this.pressed;
            await Api.like(this.targetId);
        },
        unlike: async function () {
            this.delta = this.delta - 1;
            this.pressed = !this.pressed;
            await Api.unlike(this.targetId);
        },
        toggle: function () {
            if (this.isLiked)
                this.unlike();
            else
                this.like();
        }
    },
}
</script>

<style lang="scss" scoped>    
    .like-this {
        display: flex;
        align-items: center;
        
        .like-count {
            font-size: 11px;
            margin-right: 2px;
            font-weight: 1000;
            color: #212529;
            margin-top: 1px;
        }
        
        .cmd-like {
            cursor: pointer;
            content: '♥';
            color: #DC5C68;
            display: inline-block;
            font-size: 28px;
            line-height: 28px;
            height: 28px;
        }
    }
</style>